// ─── PERSONA OPTIONS ────────────────────────────────────────────────────────
export const PERSONA_OPTIONS = [
  { value: 'ceo-founder-smb',       label: 'CEO / Founder SMB' },
  { value: 'cfo-finance-leader',    label: 'CFO / Finance Leader' },
  { value: 'cmo-marketing-leader',  label: 'CMO / Marketing Leader' },
  { value: 'cto-technical-leader',  label: 'CTO / Technical Leader' },
  { value: 'hr-people-leader',      label: 'HR / People Leader' },
  { value: 'sales-revenue-leader',  label: 'Sales / Revenue Leader' },
];

// ─── TONE OPTIONS ───────────────────────────────────────────────────────────
export const TONE_OPTIONS = [
  { value: 'professional-conversational', label: 'Professional Conversational' },
  { value: 'empathetic-inspiring',        label: 'Empathetic Inspiring' },
  { value: 'educational-authoritative',   label: 'Educational Authoritative' },
  { value: 'witty-smart',                 label: 'Witty Smart' },
  { value: 'formal-institutional',        label: 'Formal Institutional' },
  { value: 'bold-provocative',            label: 'Bold & Provocative' },
  { value: 'brand-voice',                 label: 'Brand Voice (da KB)' },
  { value: 'custom',                      label: 'Personalizzato*' },
];

// ─── OBJECTIVE OPTIONS ──────────────────────────────────────────────────────
export const OBJECTIVE_OPTIONS = [
  { value: 'brand-awareness',      label: 'Brand Awareness' },
  { value: 'customer-engagement',  label: 'Customer Engagement' },
  { value: 'drive-traffic',        label: 'Drive Traffic' },
  { value: 'increase-sales',       label: 'Increase Sales' },
  { value: 'lead-generation',      label: 'Lead Generation' },
  { value: 'product-launch',       label: 'Product Launch' },
  { value: 'recruitment',          label: 'Recruitment' },
  { value: 'thought-leadership',   label: 'Thought Leadership' },
];

// ─── LINKEDIN OPTIONS ────────────────────────────────────────────────────────
export const POST_LENGTH_OPTIONS = [
  { value: 'short',  label: 'Short (80-130 parole)' },
  { value: 'medium', label: 'Medium (130-180 parole)' },
  { value: 'long',   label: 'Long (180-250 parole)' },
];

export const CTA_TYPE_OPTIONS = [
  { value: 'soft',   label: 'Soft (domanda aperta)' },
  { value: 'medium', label: 'Medium (link in comments)' },
  { value: 'hard',   label: 'Hard (CTA diretta)' },
];

export const CAROUSEL_SLIDE_OPTIONS = [
  { value: '6',  label: '6 slide (quick tips)' },
  { value: '8',  label: '8 slide (standard)' },
  { value: '10', label: '10 slide (deep-dive)' },
];

// ─── BLOG OPTIONS ────────────────────────────────────────────────────────────
export const BLOG_LENGTH_OPTIONS = [
  { value: '400-600',   label: '400-600 (news / glossary)' },
  { value: '800-1200',  label: '800-1200 (quick guide)' },
  { value: '1500-2000', label: '1500-2000 (standard SEO)' },
  { value: '2500-3500', label: '2500-3500 (pillar content)' },
];

export const SEO_INTENT_OPTIONS = [
  { value: 'informational',  label: 'Informational (how to, what is)' },
  { value: 'commercial',     label: 'Commercial (best, comparison)' },
  { value: 'transactional',  label: 'Transactional (buy, book)' },
];

// ─── EMAIL OPTIONS ───────────────────────────────────────────────────────────
export const EMAIL_LENGTH_OPTIONS = [
  { value: 'breve',        label: 'Breve (300 parole)' },
  { value: 'standard',     label: 'Standard (500 parole)' },
  { value: 'approfondita', label: 'Approfondita (800 parole)' },
];

// ─── ADS OPTIONS ─────────────────────────────────────────────────────────────
export const ADS_CHANNEL_OPTIONS = [
  { value: 'google-search',  label: 'Google Search Ads' },
  { value: 'google-display', label: 'Google Display Ads' },
  { value: 'meta',           label: 'Meta Ads (Facebook/Instagram)' },
  { value: 'linkedin',       label: 'LinkedIn Ads' },
];

// ─── CASE STUDY OPTIONS ──────────────────────────────────────────────────────
export const CASE_STUDY_SECTION_OPTIONS = [
  { value: 'standard',  label: 'Standard (sintesi efficace)' },
  { value: 'detailed',  label: 'Dettagliato (approfondimenti)' },
];

export const CASE_STUDY_FOCUS_OPTIONS = [
  { value: 'results',    label: 'Risultati e ROI' },
  { value: 'process',    label: 'Processo e metodologia' },
  { value: 'innovation', label: 'Innovazione' },
];

export const LANDING_HEADLINE_OPTIONS = [
  { value: 'problem-solution', label: 'Problem-Solution' },
  { value: 'benefit-driven',   label: 'Benefit-Driven' },
  { value: 'question-based',   label: 'Question-Based' },
];
